import { NgModule } from '@angular/core';
import { PerformanceMetricComponent } from './components/performance-metric/performance-metric.component';
import { EllipsisLoaderComponent } from './components/ellipsis-loader/ellipsis-loader.component';
import { CommonModule } from '@angular/common';
import { MapColorGradientLegendComponent } from './components/map-color-gradient-legend/map-color-gradient-legend.component';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { TimePeriodLabelPipe } from './pipes/time-period-label.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlStatusIndicatorComponent } from './components/control-status-indicator/control-status-indicator.component';
import { SpinnerLoaderComponent } from './components/spinner-loader/spinner-loader.component';
import { RailPerformanceBindingDirective } from './services/data/rail-performance-binding.directive';
import { TrendComponent } from './components/trend/trend.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateRangeModule } from '@progress/kendo-angular-dateinputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { MultiViewCalendarModule } from '@progress/kendo-angular-dateinputs';
import { COMMON_KENDO_IMPORTS } from '../../common/common-imports';
import { InfoTooltipComponent } from '../../components/info-tooltip/info-tooltip.component';
import { GenericPerformanceMetricComponent } from './components/generic-performance-metric/generic-performance-metric.component';
import { GenericTrendComponent } from './components/generic-trend/generic-trend.component';
import { CollapsibleSectionComponent } from './components/collapsible-section/collapsible-section.component';
import { DashboardTitleComponent } from './components/dashboard-title/dashboard-title.component';
import { SingleSelectMenuComponent } from './components/single-select-menu/single-select-menu.component';
import { GeographicAggregationFilterComponent } from './components/geographic-aggregation-filter/geographic-aggregation-filter.component';
import { TimePeriodAggregationFilterComponent } from './components/time-period-aggregation-filter/time-period-aggregation-filter.component';
import { FilterFormComponent } from './components/filter-form/filter-form.component';
import { CountriesFilterComponent } from './components/countries-filter/countries-filter.component';
import { RegionsFilterComponent } from './components/regions-filter/regions-filter.component';
import { SubRegionsFilterComponent } from './components/subregions-filter/subregions-filter.component';
import { StatesAndProvincesFilterComponent } from './components/states-and-provinces-filter/states-and-provinces-filter.component';
import { StationsFilterComponent } from './components/stations-filter/stations-filter.component';
import { LoadedEmptyFilterComponent } from './components/loaded-empty-filter/loaded-empty-filter.component';
import { TravelStatusesFilterComponent } from './components/travel-statuses-filter/travel-statuses-filter.component';
import { MotionStatusesFilterComponent } from './components/motion-statuses-filter/motion-statuses-filter.component';
import { OriginFilterComponent } from './components/origin-filter/origin-filter.component';
import { DestinationFilterComponent } from './components/destination-filter/destination-filter.component';
import { EntitiesFilterComponent } from './components/entities-filter/entities-filter.component';
import { TimePeriodDisplayTextPipe } from './pipes/time-period-display-text';
import { WeekColumnNamePipe } from './pipes/week-column-name';
import { ConvertTimePeriodToIntervalPipe } from './pipes/convert-time-period-to-interval';
import { CountryCodeToNamePipe } from './pipes/country-code-to-name-pipe';
import { StateCodeToNamePipe } from './pipes/state-code-to-name-pipe';
import { AutomaticColumnWidthPipe } from './pipes/automatic-column-width';
import { SingleSelectionEntityComponent } from './components/single-selection-entity/single-selection-entity.component';
import { BaseExportModalComponent } from './components/base-export-modal/base-export-modal.component';

@NgModule({
    imports: [
        CommonModule,
        ...COMMON_KENDO_IMPORTS,
        FormsModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        DateRangeModule,
        DropDownButtonModule,
        ButtonsModule,
        InputsModule,
        LabelModule,
        MultiViewCalendarModule,
        LayoutModule,
        PopupModule,
        DropDownsModule,
        InfoTooltipComponent,
        EllipsisLoaderComponent,
        DashboardTitleComponent,
        CollapsibleSectionComponent,
        SingleSelectMenuComponent,
        GeographicAggregationFilterComponent,
        TimePeriodAggregationFilterComponent,
        FilterFormComponent,
        CountriesFilterComponent,
        RegionsFilterComponent,
        SubRegionsFilterComponent,
        StatesAndProvincesFilterComponent,
        StationsFilterComponent,
        LoadedEmptyFilterComponent,
        TravelStatusesFilterComponent,
        MotionStatusesFilterComponent,
        OriginFilterComponent,
        DestinationFilterComponent,
        SingleSelectionEntityComponent,
        EntitiesFilterComponent,
        AutomaticColumnWidthPipe,
        BaseExportModalComponent,
        ControlStatusIndicatorComponent,
        ConvertTimePeriodToIntervalPipe,
        CountryCodeToNamePipe,
        DateFilterComponent,
        DateRangeFilterComponent,
        GenericPerformanceMetricComponent,
        GenericTrendComponent,
        MapColorGradientLegendComponent,
        PerformanceMetricComponent,
        RailPerformanceBindingDirective,
        SpinnerLoaderComponent,
        StateCodeToNamePipe,
        TimePeriodDisplayTextPipe,
        TimePeriodLabelPipe,
        TrendComponent,
        WeekColumnNamePipe,
    ],
    exports: [
        AutomaticColumnWidthPipe,
        BaseExportModalComponent,
        CollapsibleSectionComponent,
        ControlStatusIndicatorComponent,
        ConvertTimePeriodToIntervalPipe,
        CountriesFilterComponent,
        CountryCodeToNamePipe,
        DashboardTitleComponent,
        DateFilterComponent,
        DateRangeFilterComponent,
        DestinationFilterComponent,
        EllipsisLoaderComponent,
        EntitiesFilterComponent,
        SingleSelectionEntityComponent,
        FilterFormComponent,
        GenericPerformanceMetricComponent,
        GenericTrendComponent,
        GeographicAggregationFilterComponent,
        InfoTooltipComponent,
        LoadedEmptyFilterComponent,
        MapColorGradientLegendComponent,
        MotionStatusesFilterComponent,
        OriginFilterComponent,
        PerformanceMetricComponent,
        RailPerformanceBindingDirective,
        RegionsFilterComponent,
        SingleSelectMenuComponent,
        SpinnerLoaderComponent,
        StateCodeToNamePipe,
        StatesAndProvincesFilterComponent,
        StationsFilterComponent,
        SubRegionsFilterComponent,
        TimePeriodAggregationFilterComponent,
        TimePeriodDisplayTextPipe,
        TimePeriodLabelPipe,
        TravelStatusesFilterComponent,
        TrendComponent,
        WeekColumnNamePipe,
    ],
    schemas: [],
})
export class SharedPlatformModule {}
